import Button from '@rio-cloud/rio-uikit/Button';
import { FormattedMessage } from 'react-intl';

export type OrderErrorProps = {
    tryAgain: () => void;
};

export const OrderError = ({ tryAgain }: OrderErrorProps) => (
    <div className='display-flex flex-column'>
        <div className='border-color-gray margin-bottom-10 rounded border bg-white padding-10'>
            <div className='flex-column display-flex gap-5 text-center'>
                <span className='uikit-icon icon-remove-sign text-color-dark' style={{ fontSize: 90 }} />
                <span className='text-size-h1 text-color-dark'>
                    <FormattedMessage id='chargingCards.unableOrder.title' />
                </span>
                <span className='text-color-dark'>
                    <FormattedMessage id='chargingCards.unableOrder.description' />
                </span>
            </div>
            <div className='margin-top-20 btn-toolbar justify-content-center'>
                <Button className='width-120' onClick={tryAgain} bsStyle='primary'>
                    <span className='padding-right-5'>
                        <FormattedMessage id='general.tryAgain' />
                    </span>
                </Button>
            </div>
        </div>
    </div>
);
